export default __webpack_public_path__ + "static/media/droplet-set-orange@2x.f2a7e1af.png";